'use client';

import { useModal } from './Modal';
import { VitaminAngelsInfoModal } from './InfoModals/VitaminAngels';
import { useTranslations } from 'next-intl';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './VitaminAngelsBanner.module.css';

const VA_LOGOMARK = getCompressedAssetUrl(
  '/web_v2/site-static/vitamin-angels/va-logomark.png',
);
const VA_LINK_ARROW = getCompressedAssetUrl(
  '/web_v2/site-static/vitamin-angels/va-link-arrow.svg',
);

export const VitaminAngelsBanner = ({ className }: { className?: string }) => {
  const t = useTranslations('common');
  const ModalClient = useModal();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    ModalClient.set(<VitaminAngelsInfoModal />);
    ModalClient.setPortal(true);
    ModalClient.show();
  };

  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      onClick={handleClick}
      aria-hidden="true"
    >
      <div className={styles.vaLogo}>
        <img
          src={VA_LOGOMARK}
          alt={t('vitaminAngelsBanner.image.alt.vitaminAngels')}
          width={36}
          height={36}
        />
      </div>
      <div>
        <p>
          {t('vitaminAngelsBanner.text.everyOrderSupports')}{' '}
          <span className={styles.vaLink}>
            {t('vitaminAngelsBanner.text.vitaminAngels')}{' '}
            <img
              className={styles.vaLinkArrow}
              src={VA_LINK_ARROW}
              alt=""
              width={12}
              height={12}
            />
          </span>
        </p>
      </div>
    </div>
  );
};
